import { DURATION_OPTIONS, FLOW3_STEPS, RHYTHM_MESSAGE, SUBJECT_OPTIONS, TYPE_OPTIONS } from "./flow3Objectives";
import { FLOW2_STEPS, FLOW2_TITLE } from "./flow2Welcome";
import { FLOW4_STEPS, FLOW4_TITLE } from "./flow4Planning";
import { FLOW5_STEPS, FLOW5_TITLE } from "./flow5Sessions";
import {
  ACTIVITY_OPTIONS,
  DIFFICULTY_OPTIONS,
  FLOW6_STEPS,
  FLOW6_TITLE,
  TIME_OPTIONS,
} from "./flow6Activities";
import { FLOW7_STEPS, FLOW7_TITLE } from "./flow7Parent";
import { FLOW8_STEPS, FLOW8_TITLE } from "./flow8PhotoHelp";
import { FLOW9_STEPS, FLOW9_TITLE } from "./flow9Agenda";
import { FLOW10_STEPS, FLOW10_TITLE } from "./flow10Propose";
import { FLOW11_STEPS, FLOW11_TITLE, FLOW12_STEPS, FLOW12_TITLE } from "./flowLot3";
import { FLOW13_STEPS, FLOW13_TITLE, FLOW14_STEPS, FLOW14_TITLE } from "./flowHome";
import { FLOW15_STEPS, FLOW15_TITLE, FLOW16_STEPS, FLOW16_TITLE, FLOW17_STEPS, FLOW17_TITLE } from "./flowWeek";
import { MVP_FLOWS } from "./flowMvp";

const STORAGE_KEY = "sp.lab.flowBlueprint.v1";

function step(flowId, index, title, messageKey, replies, relance) {
  return {
    id: `s${flowId}-${index}`,
    role: "step",
    scriptIndex: index,
    title,
    messageKey,
    prompt: "",
    message: "",
    relance: relance || { message: "", when: "" },
    replies,
  };
}

function branch(id, title, messageKey, replies = []) {
  return {
    id,
    role: "branch",
    scriptIndex: null,
    title,
    messageKey,
    prompt: "",
    message: "",
    relance: { message: "", when: "" },
    replies,
  };
}

function go(id, label, to) {
  return { id, label, to: to || "" };
}

function choices(prefix, labels, to) {
  return labels.map((label) => go(`${prefix}-${label}`, label, to));
}

function flow(id, title, nodes, audience = "eleve") {
  return { id, title, audience, nodes };
}

function parentStep(index, title, message, prompt, replies) {
  return {
    ...step(1, index, title, null, replies),
    message,
    prompt,
  };
}

export function defaultBlueprint() {
  return {
    flows: [
      {
        ...flow(
          1,
          "Flow 1 — Onboarding parent",
          [
            parentStep(0, "Accueil", "", "Accueil, principe en deux phrases, exemple au choix.", [
              go("p1-ok", "Compris", "s1-1"),
              go("p1-example", "Voir un exemple", "s1-1"),
            ]),
            parentStep(1, "Votre enfant", "", "État réel du compte de l'enfant : à inviter, en attente, expiré, activé, ou choix.", [
              go("p1-child-next", "Continuer", "s1-2"),
            ]),
            parentStep(2, "Premier engagement", "", "Proposer un premier plan d'étude : ouvre le Flow 10. Sinon : « bientôt ».", [
              go("p1-plan-now", "Proposer maintenant", "s10-0"),
              go("p1-plan-later", "Plus tard", "s1-3"),
            ]),
            parentStep(3, "Suivi et rappels", "", "Ce que le parent suivra. Bilan et textos seulement s'ils sont activés. Fin de l'onboarding : la suite se passe dans le Flow 13.", [
              go("p1-follow-ok", "C’est compris", "s13-0"),
            ]),
          ],
          "parent"
        ),
        version: 4,
      },
      {
        ...flow(
          13,
          FLOW13_TITLE,
          [
            { ...step(13, 0, FLOW13_STEPS[0], "p1.home", [go("f13-next", "Demandes d’aide / Bilan", "s13-1")]), prompt: "À chaque retour du parent : raccourcis Proposer, Suivi, Demandes d'aide, Bilan, Inviter, Menu." },
            { ...step(13, 1, FLOW13_STEPS[1], "h.parentAlert", []), prompt: "À l'ouverture : bilan en attente (Flow 12) et demandes d'aide ouvertes (Flow 11)." },
          ],
          "parent"
        ),
        version: 1,
      },
      {
        ...flow(
          14,
          FLOW14_TITLE,
          [
            { ...step(14, 0, FLOW14_STEPS[0], "e.active", [go("f14-next", "Je bloque / Mon bilan", "s14-1")]), prompt: "À chaque retour de l'élève : propositions à accepter et activités en cours." },
            { ...step(14, 1, FLOW14_STEPS[1], "h.studentUpdate", []), prompt: "À l'ouverture : réponses du parent (Flow 11) et bilan en attente (Flow 12)." },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          15,
          FLOW15_TITLE,
          [
            { ...step(15, 0, FLOW15_STEPS[0], "e.selfIntro", [go("f15-review", "Continuer", "s15-1")]), prompt: "Même formulaire que le parent : quoi pratiquer, séances par semaine, durée, échéance. En Essentiel : 1 plan de l'élève + 1 par parent." },
            { ...step(15, 1, FLOW15_STEPS[1], null, [go("f15-create", "Créer", "s15-2")]), prompt: "Récapitulatif avant la création." },
            { ...step(15, 2, FLOW15_STEPS[2], "e.selfCreated", [go("f15-week", "Planifier ma semaine", "s16-0")]), prompt: "Le plan est actif tout de suite, puis on planifie la semaine (Flow 16)." },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          16,
          FLOW16_TITLE,
          [
            { ...step(16, 0, FLOW16_STEPS[0], "w.planWeek", [go("f16-done", "C’est planifié", "s16-1")]), prompt: "À chaque accueil (Flow 14), s'il reste des séances à placer : un jour et une heure par séance, pas de 20 min." },
            { ...step(16, 1, FLOW16_STEPS[1], "w.weekDone", [go("f16-remind", "Heure de la séance", "s17-0")]), prompt: "Chaque séance planifiée devient une tâche avec ses rappels (Flow 17)." },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          17,
          FLOW17_TITLE,
          [
            { ...step(17, 0, FLOW17_STEPS[0], "w.sms1", [go("f17-late", "Pas commencé", "s17-1"), go("f17-open", "Ouvrir le lien", "s17-2")]), prompt: "Une tâche = un rappel par texto (simulé) à l'heure de la séance. Sans séance aujourd'hui : plan prioritaire (échéance la plus proche, puis le plus en retard) à 16 h." },
            { ...step(17, 1, FLOW17_STEPS[1], "w.sms2", [go("f17-open2", "Ouvrir le lien", "s17-2")]), prompt: "+1 h et +3 h, seulement si la séance n'est pas commencée. 3 rappels au maximum, entre 8 h et 21 h." },
            { ...step(17, 2, FLOW17_STEPS[2], "w.sessionNow", [go("f17-home", "Accueil", "s14-0")]), prompt: "Le lien ouvre la séance prévue ; la réalisation se déclare sur la carte, puis retour à l'accueil." },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          18,
          MVP_FLOWS[18].title,
          [
            { ...step(18, 0, MVP_FLOWS[18].steps[0], "c.intro", [go("f18-0", "Lire mes travaux", "s18-1")]) },
            { ...step(18, 1, MVP_FLOWS[18].steps[1], "c.reading", [go("f18-1", "Vérifier", "s19-0")]) },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          19,
          MVP_FLOWS[19].title,
          [
            { ...step(19, 0, MVP_FLOWS[19].steps[0], "c.found", [go("f19-0", "C’est exact", "s19-1")]) },
            { ...step(19, 1, MVP_FLOWS[19].steps[1], "c.saved", [go("f19-1", "Proposer un horaire", "s20-0")]) },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          20,
          MVP_FLOWS[20].title,
          [
            { ...step(20, 0, MVP_FLOWS[20].steps[0], "s.askAvail", [go("f20-0", "Après l’école", "s20-1")]) },
            { ...step(20, 1, MVP_FLOWS[20].steps[1], "s.proposal", [go("f20-1", "Confirmer", "s20-2")]) },
            { ...step(20, 2, MVP_FLOWS[20].steps[2], "s.confirmed", [go("f20-2", "Questions rapides", "s21-0")]) },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          21,
          MVP_FLOWS[21].title,
          [
            { ...step(21, 0, MVP_FLOWS[21].steps[0], "q.menu", [go("f21-0", "Ma prochaine séance", "s21-1")]) },
            { ...step(21, 1, MVP_FLOWS[21].steps[1], "q.next", [go("f21-1", "Rappel", "s17-0")]) },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          22,
          MVP_FLOWS[22].title,
          [
            { ...step(22, 0, MVP_FLOWS[22].steps[0], "x.choice", [go("f22-0", "Je commence", "s22-1")]) },
            { ...step(22, 1, MVP_FLOWS[22].steps[1], "x.start", [go("f22-1", "J’ai fini", "s22-2")]) },
            { ...step(22, 2, MVP_FLOWS[22].steps[2], "x.after", [go("f22-2", "Accueil", "s14-0")]) },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          23,
          MVP_FLOWS[23].title,
          [
            { ...step(23, 0, MVP_FLOWS[23].steps[0], "a.intro", [go("f23-0", "Envoyer", "s23-1")]) },
            { ...step(23, 1, MVP_FLOWS[23].steps[1], null, [go("f23-1", "J’ai compris", "s23-2")]) },
            { ...step(23, 2, MVP_FLOWS[23].steps[2], "a.resolved", [go("f23-2", "Retour à mon plan", "s22-1")]) },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          24,
          MVP_FLOWS[24].title,
          [
            { ...step(24, 0, MVP_FLOWS[24].steps[0], "k.upcoming", [go("f24-0", "Suite", "s24-1")]) },
            { ...step(24, 1, MVP_FLOWS[24].steps[1], "k.todo", [go("f24-1", "Suite", "s24-2")]) },
            { ...step(24, 2, MVP_FLOWS[24].steps[2], "k.planned", [go("f24-2", "Suite", "s24-3")]) },
            { ...step(24, 3, MVP_FLOWS[24].steps[3], "k.start", [go("f24-3", "Commencer maintenant", "s22-1")]) },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          10,
          FLOW10_TITLE,
          [
            { ...step(10, 0, FLOW10_STEPS[0], "p1.proposeIntro", [go("f10-review", "Continuer", "s10-1")]), prompt: "Formulaire : quoi pratiquer, séances par semaine, durée, échéance." },
            { ...step(10, 1, FLOW10_STEPS[1], null, [go("f10-send", "Proposer", "s10-2"), go("f10-edit", "Modifier", "s10-0")]), prompt: "Récapitulatif avant l'envoi." },
            { ...step(10, 2, FLOW10_STEPS[2], "p1.proposed", [go("f10-back", "Continuer", "s1-3")]), prompt: "La proposition est envoyée, retour au Flow 1." },
          ],
          "parent"
        ),
        version: 1,
      },
      {
        ...flow(
          11,
          FLOW11_TITLE,
          [
            { ...step(11, 0, FLOW11_STEPS[0], "h.askIntro", [go("f11-ask", "Prévenir mon parent", "s11-1")]), prompt: "L'élève choisit l'activité et décrit ce qui bloque." },
            { ...step(11, 1, FLOW11_STEPS[1], "h.parentAlert", [go("f11-act", "Répondre / Réserver / Tuteur", "s11-2")]), prompt: "Le parent est averti dans son chat." },
            { ...step(11, 2, FLOW11_STEPS[2], "h.studentUpdate", [go("f11-done", "Traité", "s11-3")]), prompt: "Réponse, séance proposée (l'élève accepte ou demande un autre moment) ou passage au tuteur. IA cachée (aiHelp)." },
            { ...step(11, 3, FLOW11_STEPS[3], "h.parentDone", []), prompt: "La demande est marquée comme traitée." },
          ],
          "eleve"
        ),
        version: 1,
      },
      {
        ...flow(
          12,
          FLOW12_TITLE,
          [
            { ...step(12, 0, FLOW12_STEPS[0], "r.mailSim", [go("f12-login", "Lundi : connexion", "s12-1")]), prompt: "Samedi 12 h (Toronto) : courriel « Ton bilan est prêt » au parent et à l'élève." },
            { ...step(12, 1, FLOW12_STEPS[1], "r.pending", [go("f12-ask", "/bilan", "s12-2")]), prompt: "Première connexion après samedi : bilan de la semaine passée." },
            { ...step(12, 2, FLOW12_STEPS[2], "r.onDemand", []), prompt: "/bilan à tout moment : semaine en cours." },
          ],
          "parent"
        ),
        version: 1,
      },
      /* Flow 1 v1 (replaced by the V0 parent welcome, kept for reference):
          parentStep(
            0,
            "Accueil",
            "Bonjour {parent}. Je crée le suivi de {student}.",
            "Accueille le parent et annonce que tu crées le suivi de l’élève.",
            [go("p1-go", "Continuer", "s1-1")]
          ),
          parentStep(
            1,
            "Confirmation du parent",
            "Tu es bien {parent} ?",
            "Fais confirmer le prénom du parent.",
            [go("p1-me", "Oui, je suis {parent}", "s1-2")]
          ),
          parentStep(
            2,
            "Confirmation de l’élève",
            "L’élève à suivre est {student} ?",
            "Fais confirmer le prénom de l’élève.",
            [go("p1-child", "Oui, {student}", "s1-3")]
          ),
          parentStep(
            3,
            "Suivi prêt",
            "C’est prêt. {student} continue dans la vue élève. Tu recevras le bilan ici.",
            "Confirme que le suivi est créé et propose le bilan.",
            [go("p1-bilan", "Voir le bilan", "s7-0")]
          ),
        ],
        "parent"
      ),
      end of Flow 1 v1 */
      { ...flow(2, FLOW2_TITLE, [
        step(2, 0, FLOW2_STEPS[0], "f2.welcome", [
          go("f2-go", "Oui, c'est parti !", "s2-1"),
          go("f2-later", "Peut-être plus tard", "b2-later"),
        ]),
        branch("b2-later", "Report", "f2.later", [go("f2-later-back", "Reprendre", "s2-0")]),
        step(2, 1, FLOW2_STEPS[1], "f2.role", [go("f2-understood", "Super, j'ai compris !", "s2-2")]),
        step(2, 2, FLOW2_STEPS[2], "f2.ready", [
          go("f2-ready", "Oui, je suis prêt(e) !", "s2-3"),
          go("f2-question", "J'ai encore une question", "b2-question"),
        ]),
        branch("b2-question", "Question libre", "f2.question", [go("f2-resume", "Reprendre", "s2-2")]),
        step(2, 3, FLOW2_STEPS[3], "f2.avail", [go("f2-avail-ok", "Continuer", "s2-4")]),
        step(2, 4, FLOW2_STEPS[4], "f2.name", [
          go("f2-name-leo", "Léo", "b2-name"),
          go("f2-name-zoe", "Zoé", "b2-name"),
          go("f2-name-nico", "Nico", "b2-name"),
          go("f2-name-mila", "Mila", "b2-name"),
          go("f2-name-random", "Choisis pour moi", "b2-name"),
          go("f2-name-other", "Autre choix", "b2-other"),
        ]),
        branch("b2-other", "Autre prénom", "f2.nameOther", []),
        branch("b2-name", "Baptême", "f2.baptism", [go("f2-name-go", "Aller à mes objectifs", "s3-0")]),
      ]), version: 2 },
      flow(3, "Flow 3 — Collecte des objectifs", [
        step(3, 0, FLOW3_STEPS[0], "f3.intro", [
          go("f3-mention", "J'ai un contrôle de maths sur les fractions.", "s3-1"),
        ], {
          message: RHYTHM_MESSAGE,
          when: "Chaque jour, pour chaque tâche. La semaine se prépare le jeudi.",
        }),
        step(3, 1, FLOW3_STEPS[1], "f3.subject", choices("f3-subject", SUBJECT_OPTIONS, "s3-2")),
        step(3, 2, FLOW3_STEPS[2], "f3.type", [
          ...choices("f3-type", TYPE_OPTIONS, "b3-due"),
        ]),
        branch("b3-due", "Échéance", "f3.due", [go("f3-due", "Lundi 20 octobre", "s3-3")]),
        step(3, 3, FLOW3_STEPS[3], "f3.duration", choices("f3-duration", DURATION_OPTIONS, "b3-steps")),
        branch("b3-steps", "Étapes prévues", "f3.steps", [
          go("f3-steps", "Revoir le cours et faire les exercices", "s3-4"),
          go("f3-nosteps", "Pas d'étapes précises", "s3-4"),
        ]),
        step(3, 4, FLOW3_STEPS[4], "f3.confirmIntro", [go("f3-done", "Objectif créé", "")]),
      ]),
      flow(4, FLOW4_TITLE, [
        step(4, 0, FLOW4_STEPS[0], "f4.goals", [go("f4-go", "Oui, on y va !", "s4-1")]),
        step(4, 1, FLOW4_STEPS[1], "f4.avail", [go("f4-days", "Continuer", "s4-2")]),
        step(4, 2, FLOW4_STEPS[2], "f4.generate", [go("f4-see", "Voir le plan", "s4-3")]),
        step(4, 3, FLOW4_STEPS[3], "f4.review", [
          go("f4-ok", "Valider et partager", "s4-4"),
          go("f4-edit", "Modifier", "b4-modify"),
        ]),
        branch("b4-modify", "Modification du samedi", "f4.modify", [
          go("f4-shift", "Avancer le samedi à 9 h", "s4-4"),
        ]),
        step(4, 4, FLOW4_STEPS[4], "f4.active", []),
      ]),
      flow(5, FLOW5_TITLE, [
        step(5, 0, FLOW5_STEPS[0], "f5.remind", [
          go("f5-start-now", "Oui je commence !", "s5-1"),
        ], {
          message: "",
          when: "1 h avant, 10 min avant, au début. Sans réponse : 10 min après, puis 30 min après.",
        }),
        step(5, 1, FLOW5_STEPS[1], "f5.begin", [go("f5-begin", "Je commence", "s5-2")]),
        step(5, 2, FLOW5_STEPS[2], "f5.check", [
          go("f5-ok", "Tout va bien", "b5-ok"),
          go("f5-pause", "Pause", "b5-pause"),
          go("f5-end", "J'ai terminé", "s5-3"),
          go("f5-diff", "Difficulté", "s5-3"),
        ]),
        branch("b5-ok", "Tout va bien", "f5.ok", [
          go("f5-ok-again", "Tout va bien", "b5-ok2"),
          go("f5-pause-2", "Pause", "b5-pause"),
          go("f5-end-2", "J'ai terminé", "s5-3"),
          go("f5-diff-2", "Difficulté", "s5-3"),
        ]),
        branch("b5-ok2", "Ça avance", "f5.okAgain", [
          go("f5-end-3", "J'ai terminé", "s5-3"),
          go("f5-pause-3", "Pause", "b5-pause"),
          go("f5-diff-3", "Difficulté", "s5-3"),
        ]),
        branch("b5-pause", "Pause", "f5.pause", [go("f5-resume", "Je reprends", "b5-resume")]),
        branch("b5-resume", "Reprise", "f5.resume", [
          go("f5-ok-back", "Tout va bien", "b5-ok"),
          go("f5-end-back", "J'ai terminé", "s5-3"),
          go("f5-diff-back", "Difficulté", "s5-3"),
        ]),
        step(5, 3, FLOW5_STEPS[3], "f5.rate", [
          go("f5-star-5", "5 · facile", "s5-4"),
          go("f5-star-4", "4 · plutôt facile", "s5-4"),
          go("f5-star-3", "3 · moyen", "s5-4"),
          go("f5-star-2", "2 · plutôt difficile", "s5-4"),
          go("f5-star-1", "1 · difficile", "s5-4"),
          go("f5-star-0", "0 · très difficile", "s5-4"),
          go("f5-note", "Noter une difficulté", "b5-note"),
        ]),
        branch("b5-note", "Difficulté notée", "f5.note", [go("f5-note-next", "La question 3 était trop dure.", "s5-4")]),
        step(5, 4, FLOW5_STEPS[4], "f5.send", [go("f5-send", "Continuer", "")]),
      ]),
      flow(6, FLOW6_TITLE, [
        step(6, 0, FLOW6_STEPS[0], "f6.ask", [
          go("f6-now", "Je fais un retour maintenant", "s6-1"),
          go("f6-later", "Un peu plus tard", "b6-later"),
          go("f6-done", "Je l'ai déjà fait", "b6-already"),
        ]),
        branch("b6-later", "Retour reporté", "f6.later", [go("f6-later-back", "Je fais un retour maintenant", "s6-1")]),
        branch("b6-already", "Retour déjà fait", "f6.already", []),
        step(6, 1, FLOW6_STEPS[1], "f6.activities", [
          ...choices("f6-act", ACTIVITY_OPTIONS, "s6-2"),
          go("f6-acts", "Valider", "s6-2"),
        ]),
        step(6, 2, FLOW6_STEPS[2], "f6.duration", choices("f6-time", TIME_OPTIONS, "s6-3")),
        step(6, 3, FLOW6_STEPS[3], "f6.difficulty", choices("f6-diff", DIFFICULTY_OPTIONS, "b6-block")),
        branch("b6-block", "Blocage", "f6.blockage", [go("f6-block", "Décrire le blocage", "s6-4")]),
        step(6, 4, FLOW6_STEPS[4], "f6.adapt", [
          go("f6-yes", "Oui, adapte mon plan", "b6-adapted"),
          go("f6-no", "Non, tout va bien", "b6-keep"),
        ]),
        branch("b6-adapted", "Plan adapté", "f6.adapted", []),
        branch("b6-keep", "Plan inchangé", "f6.keep", []),
      ]),
      flow(7, FLOW7_TITLE, [
        step(7, 0, FLOW7_STEPS[0], "f7.hello", [go("f7-subjects", "Voir le temps par matière", "s7-1")]),
        step(7, 1, FLOW7_STEPS[1], "f7.subjects", [go("f7-progress", "Voir la progression", "s7-2")]),
        step(7, 2, FLOW7_STEPS[2], "f7.progress", [go("f7-alert", "Voir le point d'attention", "s7-3")]),
        step(7, 3, FLOW7_STEPS[3], "f7.alert", [go("f7-details", "Voir les détails", "s7-4")]),
        step(7, 4, FLOW7_STEPS[4], "f7.next", [go("f7-thanks", "Merci", "")]),
      ], "parent"),
      flow(8, FLOW8_TITLE, [
        step(8, 0, FLOW8_STEPS[0], "f8.ask", [
          go("f8-add", "Ajouter une photo", "s8-1"),
          go("f8-marge", "Photo : sondage", "s8-1"),
          go("f8-blurry", "La photo est floue", "b8-blur"),
        ]),
        branch("b8-blur", "Photo floue", "f8.blur", [go("f8-blur-back", "Renvoyer une photo", "s8-0")]),
        step(8, 1, FLOW8_STEPS[1], "f8.prompt", [
          go("f8-lost", "Je ne comprends pas", "s8-2"),
          go("f8-formula", "C'est le calcul et la formule", "b8-formula"),
        ]),
        branch("b8-formula", "Formule", "f8.formula", [go("f8-formula-next", "Continuer", "s8-3")]),
        step(8, 2, FLOW8_STEPS[2], "f8.idea", [
          go("f8-b", "B. Interroger plus de personnes", "b8-exact"),
          go("f8-a", "A. Interroger moins de personnes", "b8-hint"),
        ]),
        branch("b8-exact", "Bonne réponse", "f8.exact", [go("f8-exact-next", "Continuer", "s8-3")]),
        branch("b8-hint", "Indice échantillon", "f8.choiceHint", [go("f8-hint-back", "Réessayer", "s8-2")]),
        step(8, 3, FLOW8_STEPS[3], "f8.fiche", [
          go("f8-done", "J'ai compris", "s8-4"),
          go("f8-again", "Autre exemple", "b8-again"),
        ]),
        branch("b8-again", "Autre exemple", "f8.again", [go("f8-again-back", "Revenir au résumé", "s8-3")]),
        step(8, 4, FLOW8_STEPS[4], "f8.understood", [go("f8-tutor", "Parler à un tuteur", "b8-tutor")]),
        branch("b8-tutor", "Tuteur", "f8.tutor", []),
      ]),
      flow(9, FLOW9_TITLE, [
        step(9, 0, FLOW9_STEPS[0], "f9.ask", [
          go("f9-add", "Ajouter une photo", "s9-1"),
          go("f9-week", "Photo : semaine", "s9-1"),
          go("f9-day", "Photo : journée", "s9-1"),
          go("f9-task", "Photo : fiche", "s9-1"),
        ]),
        step(9, 1, FLOW9_STEPS[1], "f9.read", [
          go("f9-read", "Dates lues", "s9-2"),
          go("f9-blur", "Photo illisible", "b9-blur"),
        ]),
        step(9, 2, FLOW9_STEPS[2], "f9.offer", [
          go("f9-build", "Construire les plans", "s9-3"),
          go("f9-another", "Ajouter une autre photo", "s9-0"),
          go("f9-gap", "Une date manque", "b9-gap"),
        ]),
        branch("b9-gap", "Photo suivante", "f9.gap", [go("f9-gap-back", "Ajouter une photo", "s9-0")]),
        step(9, 3, FLOW9_STEPS[3], "f9.plans", [
          go("f9-activate", "Activer les plans", "s9-4"),
          go("f9-photo", "Ajouter une photo", "s9-0"),
        ]),
        step(9, 4, FLOW9_STEPS[4], "f9.done", [
          go("f9-complete", "C'est complet", "b9-complete"),
          go("f9-more", "Ajouter une photo", "s9-0"),
        ]),
        branch("b9-complete", "Agenda complet", "f9.complete", []),
        branch("b9-blur", "Photo illisible", "f9.blur", [go("f9-blur-back", "Réessayer", "s9-0")]),
      ]),
    ],
  };
}

function normalizeReply(reply) {
  return {
    id: String(reply?.id || uid("r")),
    label: String(reply?.label || "Réponse"),
    to: String(reply?.to || ""),
  };
}

function defaultRelance(id) {
  if (id === "s3-0") {
    return {
      message:
        "Tant que cette collecte n’est pas remplie, je te la redemande chaque jour. Le dimanche et le lundi, deux rappels dans la journée.",
      when: "Chaque jour tant que ce n’est pas rempli. Dimanche et lundi : deux fois.",
    };
  }
  if (id === "s5-0") {
    return {
      message: "",
      when: "1 h avant, 10 min avant, au début. Sans réponse : 10 min après, puis 30 min après.",
    };
  }
  return { message: "", when: "" };
}

function normalizeNode(node) {
  const id = String(node?.id || uid("n"));
  return {
    id,
    role: node?.role === "branch" ? "branch" : "step",
    scriptIndex: Number.isInteger(node?.scriptIndex) ? node.scriptIndex : null,
    title: String(node?.title || "Étape"),
    messageKey: node?.messageKey || null,
    prompt: String(node?.prompt || ""),
    message: String(node?.message || ""),
    relance: node?.relance
      ? {
          message: String(node.relance.message || ""),
          when: String(node.relance.when || ""),
        }
      : defaultRelance(id),
    replies: Array.isArray(node?.replies) ? node.replies.map(normalizeReply) : [],
  };
}

function sameIds(flow, previous) {
  const ids = (flow?.nodes || []).map((node) => node.id);
  return ids.length === previous.length && ids.every((id, index) => id === previous[index]);
}

function isPreviousFlow2(flow) {
  if (sameIds(flow, ["s2-0", "b2-later", "s2-1", "s2-2", "b2-question", "s2-3", "s2-4"])) {
    return true;
  }
  if (sameIds(flow, ["s2-0", "b2-later", "s2-1", "s2-2", "b2-question", "s2-3"])) {
    const avail = (flow.nodes || []).find((node) => node.id === "s2-3");
    return avail?.messageKey !== "f2.avail";
  }
  return sameIds(flow, ["s2-0", "b2-later", "s2-1", "s2-2", "b2-question"]);
}

function isPreviousFlow5(flow) {
  return (
    sameIds(flow, [
      "s5-0",
      "b5-later",
      "s5-1",
      "b5-15",
      "b5-60",
      "s5-2",
      "s5-3",
      "b5-hint",
      "b5-fix",
      "b5-ask",
      "s5-4",
      "b5-plan",
    ]) ||
    sameIds(flow, ["s5-0", "s5-1", "s5-2", "s5-3", "b5-note", "s5-4"])
  );
}

function linkPlanReview(flow) {
  if (!sameIds(flow, ["s4-0", "s4-1", "s4-2", "s4-3", "b4-modify", "s4-4"])) return flow;
  return {
    ...flow,
    nodes: flow.nodes.map((node) => {
      if (node.id !== "s4-4") return node;
      return {
        ...node,
        replies: (node.replies || []).filter((reply) => reply.id !== "f4-mine"),
      };
    }),
  };
}

const DIFFICULTY_LABELS = {
  "f5-star-5": "5 · facile",
  "f5-star-4": "4 · plutôt facile",
  "f5-star-3": "3 · moyen",
  "f5-star-2": "2 · plutôt difficile",
  "f5-star-1": "1 · difficile",
  "f5-star-0": "0 · très difficile",
};

function ensureSessionChoices(flow) {
  const additions = {
    "s5-2": [["f5-diff", "Difficulté", "s5-3"]],
    "b5-ok": [["f5-diff-2", "Difficulté", "s5-3"]],
    "b5-ok2": [["f5-diff-3", "Difficulté", "s5-3"]],
    "b5-resume": [["f5-diff-back", "Difficulté", "s5-3"]],
  };
  return {
    ...flow,
    nodes: (flow.nodes || []).map((node) => {
      const extra = additions[node.id];
      if (!extra) return node;
      const replies = [...(node.replies || [])].filter(
        (reply) => !String(reply.id || "").startsWith("f5-collect") && reply.label !== "Valider et partager"
      );
      extra.forEach(([id, label, to]) => {
        if (!replies.some((reply) => reply.id === id)) replies.push({ id, label, to });
      });
      return { ...node, replies };
    }),
  };
}

function ensureTaskReminder(flow) {
  return {
    ...flow,
    nodes: (flow.nodes || []).map((node) => {
      if (node.id !== "s5-0") return node;
      const hasStart = (node.replies || []).some((reply) => reply.id === "f5-start-now");
      if (hasStart && node.messageKey === "f5.remind") return node;
      return {
        ...node,
        title: "Rappel",
        messageKey: "f5.remind",
        replies: [{ id: "f5-start-now", label: "Oui je commence !", to: "s5-1" }],
      };
    }),
  };
}

function labelDifficulty(flow) {
  return {
    ...flow,
    nodes: (flow.nodes || []).map((node) => ({
      ...node,
      replies: (node.replies || []).map((reply) => {
        if (DIFFICULTY_LABELS[reply.id]) return { ...reply, label: DIFFICULTY_LABELS[reply.id] };
        if (reply.id === "f5-send" || reply.label === "Envoyer au tuteur") {
          return { ...reply, label: "Continuer" };
        }
        return reply;
      }),
    })),
  };
}

function normalizeFlow(flow, fallback) {
  const replace =
    (flow?.id === 2 && isPreviousFlow2(flow)) || (flow?.id === 5 && isPreviousFlow5(flow));
  const source = replace ? fallback : flow?.nodes ? flow : fallback;
  const normalized = {
    id: source.id,
    version: fallback.version || 1,
    title: String(source.title || fallback.title),
    audience:
      source.audience === "parent" || source.audience === "eleve"
        ? source.audience
        : fallback.audience || "eleve",
    nodes: (source.nodes || []).map(normalizeNode),
  };
  if (normalized.id === 2) return ensureTutorName(normalized);
  if (normalized.id === 3) return refreshObjectiveRhythm(normalized);
  if (normalized.id === 4) return linkPlanReview(normalized);
  if (normalized.id === 5) return ensureTaskReminder(ensureSessionChoices(labelDifficulty(normalized)));
  return normalized;
}

const PREVIOUS_OBJECTIVE_NUDGE =
  "Tant que cette collecte n’est pas remplie, je te la redemande chaque jour. Le dimanche et le lundi, deux rappels dans la journée.";

function refreshObjectiveRhythm(flow) {
  return {
    ...flow,
    nodes: (flow.nodes || []).map((node) => {
      if (node.id !== "s3-0") return node;
      const current = node.relance?.message || "";
      if (current && current !== PREVIOUS_OBJECTIVE_NUDGE) return node;
      return {
        ...node,
        relance: {
          message: RHYTHM_MESSAGE,
          when: "Chaque jour, pour chaque tâche. La semaine se prépare le jeudi.",
        },
      };
    }),
  };
}

function ensureOtherName(flow) {
  const nodes = flow.nodes || [];
  if (nodes.some((node) => (node.replies || []).some((reply) => reply.id === "f2-name-other"))) return flow;
  const withReply = nodes.map((node) => {
    if (node.id !== "s2-4") return node;
    return {
      ...node,
      replies: [...(node.replies || []), go("f2-name-other", "Autre choix", "b2-other")],
    };
  });
  return {
    ...flow,
    nodes: nodes.some((node) => node.id === "b2-other")
      ? withReply
      : [...withReply, branch("b2-other", "Autre prénom", "f2.nameOther", [])],
  };
}

function ensureTutorName(flow) {
  if ((flow.nodes || []).some((node) => node.id === "s2-4")) return ensureOtherName(flow);
  const fallback = defaultBlueprint().flows.find((item) => item.id === 2);
  const extra = (fallback.nodes || []).filter(
    (node) => node.id === "s2-4" || node.id === "b2-name" || node.id === "b2-other"
  );
  return {
    ...flow,
    nodes: [
      ...(flow.nodes || []).map((node) => {
        if (node.id !== "s2-3") return node;
        return {
          ...node,
          replies: (node.replies || []).map((reply) =>
            reply.to === "s3-0" ? { ...reply, to: "s2-4" } : reply
          ),
        };
      }),
      ...extra,
    ],
  };
}

export function normalizeBlueprint(raw) {
  const base = defaultBlueprint();
  const saved = Array.isArray(raw?.flows) ? raw.flows : [];
  return {
    flows: base.flows.map((fallback) => {
      const found = saved.find((flow) => flow?.id === fallback.id);
      // A new version of a default flow replaces the copy saved in this browser.
      if (found && (found.version || 1) !== (fallback.version || 1)) return fallback;
      return found ? normalizeFlow(found, fallback) : fallback;
    }),
  };
}

export function loadFlowBlueprint() {
  try {
    if (typeof localStorage === "undefined") return defaultBlueprint();
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultBlueprint();
    return normalizeBlueprint(JSON.parse(raw));
  } catch {
    return defaultBlueprint();
  }
}

export function saveFlowBlueprint(blueprint) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(blueprint));
  } catch {
    // The in-memory tree still applies for this visit.
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("sp-lab-blueprint", { detail: blueprint }));
  }
}

export function uid(prefix) {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}

export function flowsByAudience(blueprint, audience) {
  return blueprint.flows.filter((item) => (item.audience || "eleve") === audience);
}

export function findFlow(blueprint, flowId) {
  return blueprint.flows.find((flow) => flow.id === flowId) || blueprint.flows[0];
}

export function findNode(blueprint, flowId, nodeId) {
  return findFlow(blueprint, flowId).nodes.find((node) => node.id === nodeId) || null;
}

export function spineNodes(flow) {
  return flow.nodes.filter((node) => node.role === "step");
}

function mapFlow(blueprint, flowId, recipe) {
  return {
    flows: blueprint.flows.map((flow) => (flow.id === flowId ? recipe(flow) : flow)),
  };
}

function mapNode(flow, nodeId, recipe) {
  return {
    ...flow,
    nodes: flow.nodes.map((node) => (node.id === nodeId ? recipe(node) : node)),
  };
}

export function moveStep(blueprint, flowId, nodeId, direction) {
  return mapFlow(blueprint, flowId, (flow) => {
    const indexes = flow.nodes.map((node, index) => (node.role === "step" ? index : -1)).filter((index) => index >= 0);
    const pos = indexes.findIndex((index) => flow.nodes[index].id === nodeId);
    const target = indexes[pos + direction];
    if (pos < 0 || target == null) return flow;
    const nodes = flow.nodes.slice();
    const from = indexes[pos];
    [nodes[from], nodes[target]] = [nodes[target], nodes[from]];
    return { ...flow, nodes };
  });
}

export function removeNode(blueprint, flowId, nodeId) {
  return mapFlow(blueprint, flowId, (flow) => {
    const steps = spineNodes(flow);
    const target = flow.nodes.find((node) => node.id === nodeId);
    if (!target) return flow;
    if (target.role === "step" && steps.length <= 1) return flow;
    return {
      ...flow,
      nodes: flow.nodes
        .filter((node) => node.id !== nodeId)
        .map((node) => ({
          ...node,
          replies: node.replies.map((reply) => (reply.to === nodeId ? { ...reply, to: "" } : reply)),
        })),
    };
  });
}

export function addStep(blueprint, flowId, afterId) {
  const id = uid("s");
  const node = {
    id,
    role: "step",
    scriptIndex: null,
    title: "Nouvelle étape",
    messageKey: null,
    prompt: "Décris ce que le tuteur dit à cette étape. Une consigne courte.",
    message: "",
    relance: { message: "", when: "" },
    replies: [go(uid("r"), "Continuer", "")],
  };
  return {
    blueprint: mapFlow(blueprint, flowId, (flow) => {
      const nodes = flow.nodes.slice();
      const at = nodes.findIndex((item) => item.id === afterId);
      nodes.splice(at < 0 ? nodes.length : at + 1, 0, node);
      return { ...flow, nodes };
    }),
    nodeId: id,
  };
}

export function addReply(blueprint, flowId, nodeId) {
  const id = uid("r");
  return {
    blueprint: mapFlow(blueprint, flowId, (flow) =>
      mapNode(flow, nodeId, (node) => ({
        ...node,
        replies: [...node.replies, go(id, "Nouvelle réponse", "")],
      }))
    ),
    replyId: id,
  };
}

export function updateReply(blueprint, flowId, nodeId, replyId, patch) {
  return mapFlow(blueprint, flowId, (flow) =>
    mapNode(flow, nodeId, (node) => ({
      ...node,
      replies: node.replies.map((reply) => (reply.id === replyId ? { ...reply, ...patch } : reply)),
    }))
  );
}

export function removeReply(blueprint, flowId, nodeId, replyId) {
  return mapFlow(blueprint, flowId, (flow) =>
    mapNode(flow, nodeId, (node) => ({
      ...node,
      replies: node.replies.filter((reply) => reply.id !== replyId),
    }))
  );
}

export function addBranch(blueprint, flowId, nodeId, replyId) {
  const id = uid("b");
  const node = {
    id,
    role: "branch",
    scriptIndex: null,
    title: "Nouveau chemin",
    messageKey: null,
    prompt: "Décris cette branche. Une consigne courte.",
    message: "",
    relance: { message: "", when: "" },
    replies: [],
  };
  return {
    blueprint: mapFlow(blueprint, flowId, (flow) => {
      const nodes = flow.nodes.slice();
      const at = nodes.findIndex((item) => item.id === nodeId);
      nodes.splice(at < 0 ? nodes.length : at + 1, 0, node);
      return mapNode({ ...flow, nodes }, nodeId, (current) => ({
        ...current,
        replies: current.replies.map((reply) => (reply.id === replyId ? { ...reply, to: id } : reply)),
      }));
    }),
    nodeId: id,
  };
}

export function updateNode(blueprint, flowId, nodeId, patch) {
  return mapFlow(blueprint, flowId, (flow) => mapNode(flow, nodeId, (node) => ({ ...node, ...patch })));
}

export function resetFlow(blueprint, flowId) {
  const fresh = defaultBlueprint().flows.find((flow) => flow.id === flowId);
  return mapFlow(blueprint, flowId, () => fresh);
}

export function linkedIds(flow) {
  const ids = new Set();
  flow.nodes.forEach((node) => node.replies.forEach((reply) => reply.to && ids.add(reply.to)));
  return ids;
}
